<!-- 租宝分成｜售宝分成 -->
<template>
  <div
    ref="con"
    class="month-bill-container"
    :class="{ 'is-agent': isAgentUser }"
  >
    <TitlePoi
      v-if="isAgentUser"
      :is-agent-user="true"
      :show-all-pois="false"
      @poiChangeCallback="poiChangeCallback"
    />
    <div class="header">
      <span
        v-if="isSaleType"
        class="col-left"
      >售宝数量：{{ saleCount }}</span>
      <span class="col-right">我的分成：{{ divideAmount | formatAmount }}元</span>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了～"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getData"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        class="panel-box"
      >
        <div class="panel-head">
          <span class="head-left">
            <span class="head-title">
              <span>{{ item.cutMonth | getMonth }}月</span>
              <span class="poi-name">{{ item.poiName }}</span>
            </span>
          </span>
          <span
            class="head-right"
            @click="gotoPage(item)"
          >
            查看明细
            <img
              class="icon-arrow"
              src="@/assets/img/arrow-right@2x.png"
            /></span>
        </div>
        <div class="panel-content">
          <div class="row">
            <span>
              <span
                v-if="isSaleType"
                class="col-left"
              >
                售宝数量：<span>{{ item.saleCount }}个</span>
              </span>
              <span
                v-else-if="item.isDividedPropVisible"
                class="col-left"
              >
                参与分成：<span>{{ item.rentGtv | formatAmount }}元</span>
              </span>
            </span>
            <span class="col-right">
              我的分成：<span class="number">{{ item.settleDivided | formatAmount }}元</span>
            </span>
          </div>
          <pre-paid-tip
            v-if="item.prepaidBill"
          />
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import List from 'vant/lib/list';
import { getMonth } from '@/util/filter';
import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import { BILLTYPE } from '@/constants/bill';
import PrePaidTip from '@/views/bill/components/PrePaidTip';
import TitlePoi from '@/components/TitlePoi';

export default {
  name: 'MonthBillList',
  filters: {
    getMonth,
  },
  components: {
    [List.name]: List,
    PrePaidTip,
    TitlePoi,
  },
  data() {
    return {
      type: 0, // 0:租宝、1:售宝
      divideAmount: 0, // 我的分成
      saleCount: 0, // 售宝数量
      settleUnitMode: 0, // 结算单元模式，0：直营三方 3：合作商
      loading: false,
      finished: false,
      error: false,
      pageNum: 1,
      pageSize: 10,
      list: [],
      scrollTop: 0,
      changed: false,
      billInfo: {},
    };
  },
  computed: {
    ...mapState(['currentPoi']),
    ...mapGetters(['isAgentUser']),
    ...mapState('billModule', ['customerId', 'currentUnbilledInfo', 'currentBilledInfo']),
    isSaleType() {
      return this.type === BILLTYPE.SALE;
    },
  },
  mounted() {
    this.init();
  },
  activated() {
    if (this.changed) {
      this.init();
    } else {
      const ref = this.$refs.con;
      if (ref) {
        ref.scrollTop = this.scrollTop;
      }
    }
  },
  methods: {
    ...mapMutations('billModule', ['setCurrentPoiBillInfo']),
    init() {
      const { from, type } = this.$route.query;
      this.type = Number(type);
      const billInfo = from === 'unbilled' ? this.currentUnbilledInfo : this.currentBilledInfo;
      this.billInfo = billInfo;
      const {
        cutMonth, settleUnitId, saleCount, saleDivideAmount, rentDivideAmount, settleUnitMode,
      } = billInfo;
      this.saleCount = saleCount;
      this.divideAmount = this.type === BILLTYPE.RENT ? rentDivideAmount : saleDivideAmount;
      this.settleUnitId = settleUnitId;
      this.cutMonth = cutMonth;
      this.settleUnitMode = settleUnitMode;

      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.error = false;
      this.loading = false;
      this.getData();
    },
    async getData() {
      const { from } = this.$route.query;
      const params = {
        customerId: this.customerId,
        settleUnitId: this.settleUnitId,
        billType: from === 'unbilled' ? 0 : 1,
        divideType: this.type,
        month: this.cutMonth,
        settleUnitMode: this.settleUnitMode,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.isAgentUser && this.currentPoi.poiId) {
        params.poiId = this.currentPoi.poiId;
      }
      this.loading = true;
      const res = await BillApi.getMonthBillList(params);
      if (res.code === STATUS.SUCCESS && res.data) {
        const { isFinished = true, content } = res.data;
        this.list = this.list.concat(content || []);
        this.finished = isFinished;
        if (this.isAgentUser && this.currentPoi.poiId) { // && this.currentPoi.poiId
          this.saleCount = res.data.saleItemCount;
          this.divideAmount = res.data.myDividend;
        } else {
          this.saleCount = this.billInfo.saleCount;
          this.divideAmount = this.type === BILLTYPE.RENT ? this.billInfo.rentDivideAmount : this.billInfo.saleDivideAmount;
        }
        if (!this.finished) {
          this.pageNum += 1;
        }
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    gotoPage(data, isRedirect) {
      this.setCurrentPoiBillInfo(data);
      const location = {
        name: 'MonthBillDetail',
        query: { type: this.type, from: this.$route.query.from },
      };
      return isRedirect ? this.$router.replace(location) : this.$router.push(location);
    },
    poiChangeCallback() {
      this.list = [];
      this.loading = true;
      this.finished = false;
      this.pageNum = 1;
      this.getData();
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.type) {
      document.title = Number(to.query.type) === BILLTYPE.RENT ? '租宝分成' : '售宝分成';
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.changed = to.name !== 'MonthBillDetail';
    // this.$route.meta.keepAlive = to.name === 'MonthBillDetail';
    const ref = this.$refs.con;
    if (ref) {
      this.scrollTop = ref.scrollTop;
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/page/bill.scss";

.month-bill-container {
  height: 100vh;
  overflow: auto;
  &.is-agent {
    padding-top: 1rem;
  }
  .icon-arrow {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-left: 12px;
  }
  .poi-name {
    margin-left: 16px;
  }
}
</style>
